/** The API books and buckets in Europe/Berlin; dates follow it, not the browser's zone. */
const BERLIN = 'Europe/Berlin';

const berlinCalendarDay = new Intl.DateTimeFormat('en-US', {
  timeZone: BERLIN,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
});

const berlinParts = (iso: string) => {
  const parts = berlinCalendarDay.formatToParts(new Date(iso));
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((candidate) => candidate.type === type)?.value ?? '';
  return { year: part('year'), month: part('month'), day: part('day') };
};

/** The `YYYY-MM` a timestamp falls in on the Berlin calendar. */
export const berlinYearMonth = (iso: string) => {
  const { year, month } = berlinParts(iso);
  return `${year}-${month}`;
};

/** The `YYYY-MM-DD` a timestamp falls on in Berlin. */
export const berlinIsoDate = (iso: string) => {
  const { year, month, day } = berlinParts(iso);
  return `${year}-${month}-${day}`;
};
